import { render } from "./limit-exceptions-upload-page.vue?vue&type=template&id=4cc57613&ts=true"
import script from "./limit-exceptions-upload-page.ts?vue&type=script&lang=ts"
export * from "./limit-exceptions-upload-page.ts?vue&type=script&lang=ts"

import "./limit-exceptions-upload-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__